import { authReducer } from '@features/auth/authSlice';
import { combineReducers } from '@reduxjs/toolkit';
import { baseApi } from '@services/api/baseApi';
import { colorModeReducer } from '@theme/colorModeSlice';

export const rootReducer = combineReducers({
  colorMode: colorModeReducer,
  auth: authReducer,
  [baseApi.reducerPath]: baseApi.reducer,
});

export type RootReducerState = ReturnType<typeof rootReducer>;
